export class Special {

    public id:string
    public isActive:boolean = true
    public title: string
    public desc: string
    public img: string
    public position: number = -1
    public color: string = "serviceyellow"
    public id2Link:number //kann Kategorie oder Item sein oder Bonuskarte
    public bonuscardSpecial:boolean = false //kann auch auf Bonuskarte verlinken anstatt auf Kategorie

    public constructor(restaurantKey:string) {
        this.id = ('')+new Date().getTime()+restaurantKey
        this.img = 'assets/imgs/specials/special_15.jpg'
    }

}
